import { jsx as _jsx } from "react/jsx-runtime";
import useWizard from "./useWizard";
export const WizardPanel = ({ unstyled = false, children, }) => {
    const [{ currentStep }] = useWizard();
    return (_jsx("div", { id: `eco-wizard-panel-${currentStep}`, "data-eco-component": "wizard-panel", className: unstyled ? "" : "bg-container-light dark:bg-dark-container-light", children: children }));
};
export default WizardPanel;
